"use client";

import { Building2, Palmtree, Home, Bed, Hotel, Key } from "lucide-react";
import styles from "./TrustedBy.module.css";

export default function TrustedBy() {
  const categories = [
    { name: "Boutique Hotels", icon: <Building2 size={24} /> },
    { name: "Resorts", icon: <Palmtree size={24} /> },
    { name: "Homestays", icon: <Home size={24} /> },
    { name: "Hostels", icon: <Bed size={24} /> },
    { name: "Hotel Chains", icon: <Hotel size={24} /> },
    { name: "Service Apartments", icon: <Key size={24} /> },
  ];

  return (
    <section className={styles.trusted} id="trusted">
      <div className={`${styles.container} container`}>
        <h2 className={styles.title}>Trusted by Hotels of All Sizes</h2>
        
        <div className={styles.grid}>
          {categories.map((cat, idx) => (
            <div key={idx} className={styles.card}>
              <div className={styles.iconWrapper}>{cat.icon}</div>
              <span className={styles.name}>{cat.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
